import OmniApiClient from "./base";

const RESOURCE = "/prepbusiness/credentials";

export default {
  // Get all credentials
  getAll(params) {
    return OmniApiClient.get(`${RESOURCE}/`, { params });
  },

  // Get credential by ID
  get(id) {
    return OmniApiClient.get(`${RESOURCE}/${id}`);
  },

  // Create new credential
  create(data) {
    return OmniApiClient.post(`${RESOURCE}/`, data);
  },

  // Update credential
  update(id, data) {
    return OmniApiClient.put(`${RESOURCE}/${id}`, data);
  },

  // Delete credential
  delete(id) {
    return OmniApiClient.delete(`${RESOURCE}/${id}`);
  },

  // Toggle active status
  toggleActive(id) {
    return OmniApiClient.post(`${RESOURCE}/${id}/toggle-active`);
  },

  // Test saved credentials
  testSaved(id) {
    return OmniApiClient.post(`${RESOURCE}/${id}/test`);
  },

  // Test form credentials
  test(data) {
    return OmniApiClient.post(`${RESOURCE}/test`, data);
  },

  // --- Cliques ---
  getCliques(params) {
    return OmniApiClient.get(`/prepbusiness/cliques/`, { params });
  },

  createClique(data) {
    return OmniApiClient.post(`/prepbusiness/cliques/`, data);
  },

  updateClique(id, data) {
    return OmniApiClient.put(`/prepbusiness/cliques/${id}`, data);
  },

  deleteClique(id) {
    return OmniApiClient.delete(`/prepbusiness/cliques/${id}`);
  },

  // Optional: Batch upload for sheets (if it's handled via credentials API somehow, or separate)
  // The backend has `/prepbusiness/sheets/batch`
  sendBatch(payload) {
    // If token is missing, inject it from env or use empty string

    payload.token =
      import.meta.env.VITE_SHEETS_TOKEN ||
      "23q98n7zh7cfdwsnsdpksdamNSI8adjhkdajs8hndnao123e4fcdsfggfdhujlycxaasd";

    return OmniApiClient.post(`/prepbusiness/sheets/batch`, payload);
  },
};
